import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBV2dum79Q46OEhVLFCgYheMx81DfxuY1w",
  authDomain: "contalearn.firebaseapp.com",
  projectId: "contalearn",
  storageBucket: "contalearn.firebasestorage.app",
  messagingSenderId: "966545693931",
  appId: "1:966545693931:web:4cecb265d3286f943ff2ae"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

export const VAPID_KEY = "BEgMsMsBpKJ2uRe2j6k6reNvcgerombVl5TFvUCFuwXU_ZYt2Y1HdhZrcwlBdo72J1u2TJ28ROReLLzbAm4o-J8";

